import { Col, Row, Tooltip } from "antd";
import { colors } from "../../../../utils/colors/colors";

const CompanyDisplay: React.FC<{ companies: string[] }> = ({ companies }) => {
    const companiesArray = companies.filter(c => c && c.trim());

    if (companiesArray.length === 0) return <span>-</span>;

    if (companiesArray.length === 1) {
        const company = companiesArray[0];
        const isLong = company.length > 15;
        const truncatedCompany = isLong ? `${company.substring(0, 15)}...` : company;

        return isLong ? (
            <Tooltip color={colors.blueitOrange} title={company} placement="top">
                <span style={{ cursor: 'pointer' }}>{truncatedCompany}</span>
            </Tooltip>
        ) : (
            <span>{company}</span>
        );
    }

    const firstCompany = companiesArray[0];
    const isFirstCompanyLong = firstCompany.length > 15;
    const truncatedFirstCompany = isFirstCompanyLong ? `${firstCompany.substring(0, 15)}...` : firstCompany;
    const remainingCount = companiesArray.length - 1;

    return (
        <Row align="middle" gutter={8}>
            <Col>
                {isFirstCompanyLong ? (
                    <Tooltip color={colors.blueitOrange} title={firstCompany} placement="top">
                        <span style={{ cursor: 'pointer' }}>{truncatedFirstCompany}</span>
                    </Tooltip>
                ) : (
                    <span>{firstCompany}</span>
                )}
            </Col>
            <Col>
                <Tooltip color={colors.blueitOrange} title={
                    <Row justify={"center"}>
                        {companiesArray.slice(1).map((company, index) => (
                            <Col style={{ textAlign: "center", fontSize: "16px" }} span={24} key={index}>{company}</Col>
                        ))}
                    </Row>
                } placement="top">
                    <span style={{
                        cursor: 'pointer',
                        backgroundColor: colors.blueitOrange,
                        border: `1px solid ${colors.blueitOrange}`,
                        borderRadius: '50%',
                        color: "#ffff",
                        fontSize: '11px',
                        fontWeight: 600,
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: "5px",
                        lineHeight: 1,
                    }}>
                        +{remainingCount}
                    </span>
                </Tooltip>
            </Col>
        </Row>
    );
};

export default CompanyDisplay;